import { defineMessages } from "react-intl";

const baseId = "t.components.LanguageSelect.";

export default defineMessages({
  label: {
    id: baseId + "label",
    defaultMessage: "Language",
  },
  it: {
    id: baseId + "it",
    defaultMessage: "italian",
  },
  en: {
    id: baseId + "en",
    defaultMessage: "english",
  },
});
